<section fxLayout="row" class="full-height">
  <div fxLayout="column" fxFlex.gt-md="51" fxFlex.gt-sm="75" class="full-height">
    <mat-card class="full-max-height-with-toolbar card-width">
      <mat-card-header fxLayout="row" fxLayoutAlign="start center">
        <div mat-card-avatar>
          <mat-icon svgIcon="warning-blue"></mat-icon>
        </div>
        <mat-card-title class="antialiased" fxLayout="row wrap" fxLayoutAlign="start start">
          <h3>{{ 'DESIGN_LIBRARY.DUPLICATE_NAME.TITLE' | bmsTranslate }}</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="form-scrollable-content">
        <article fxLayout="column" fxLayoutGap="16px" class="duplicate-name-article">
          {{ 'DESIGN_LIBRARY.DUPLICATE_NAME.INFO' | bmsTranslate }}
          <ul fxLayout="column" fxLayoutGap="16px">
            <li *ngFor="let name of duplicateNames" class="duplicate-name-list-item">
              {{ name }}
            </li>
          </ul>
          <p class="b1 duplicate-name-question">{{ 'DESIGN_LIBRARY.DUPLICATE_NAME.SUBTITLE' | bmsTranslate }}</p>
          <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="16px">
            <button mat-flat-button color="primary" type="button" (click)="decideForEachDrawingClicked()">{{ 'DESIGN_LIBRARY.DUPLICATE_NAME.CHANGE_DRAWING_NAME' | bmsTranslate }}</button>
            <button mat-stroked-button color="primary" type="button" (click)="skipDuplicatesClicked()">{{ 'DESIGN_LIBRARY.DUPLICATE_NAME.SKIP_DUPLICATE' | bmsTranslate }}</button>
            <button mat-stroked-button appDataCy="override-duplicate-drawings" color="primary" type="button" (click)="overwriteDuplicatesClicked()">
              {{ 'DESIGN_LIBRARY.DUPLICATE_NAME.OVERWRITE_DUPLICATE' | bmsTranslate }}
            </button>
          </div>
        </article>
      </mat-card-content>
    </mat-card>
  </div>
</section>
